import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import EventCalendarWidget from "./EventCalendarWidget";

export default function FeaturedClasses() {
  return (
    <section
      className="relative bg-ivory text-espresso pt-32 md:pt-48 pb-20 md:pb-24"
      data-testid="featured-classes-section"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-20 items-end">
          <Reveal className="md:col-span-8">
            <p className="text-[11px] uppercase tracking-[0.3em] text-olive mb-6">Upcoming at the table</p>
            <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-editorial leading-[0.92]">
              A <em className="not-italic text-terracotta">calendar</em><br />
              of culinary experiences.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-3 md:col-start-10">
            <Link
              to="/classes"
              data-testid="featured-view-all"
              className="text-[11px] uppercase tracking-[0.22em] editorial-underline"
            >
              View the full calendar →
            </Link>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <EventCalendarWidget />
        </Reveal>
      </div>
    </section>
  );
}
